// extracted by mini-css-extract-plugin
export default {"comments":"CommentSection_comments__GoWSK","heading":"CommentSection_heading__UAGD2"};